import useInputChange from "hooks/useInputChange";
import { ChangeEvent, FormEvent, useEffect } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { uploadeFile } from "services/file.service";
import { ServiceCategory } from "types/general.interface";

interface Props {
  onSubmit: (record: ServiceCategory) => void;
  data: ServiceCategory | null;
  isLoading?: boolean;
  onCancel: () => void;
}
export default function CategoryForm({
  onSubmit,
  data,
  isLoading,
  onCancel,
}: Props) {
  const { state, onChange, onChangeByNameValue, setState } =
    useInputChange<ServiceCategory>({
      name: "",
      description: "",
      coverPhoto: undefined,
    });

  useEffect(() => {
    if (data) {
      setState(data);
    }
  }, [data]);

  const { mutate: uploadMutate } = useMutation(
    async (file: FormData) => await uploadeFile(file),
    {
      onSuccess(data) {
        const file: ServiceCategory["coverPhoto"] = {
          name: data?.data.name || "any",
          url: data?.data.url,
          id: data?.data.id,
          size: data?.data.size,
        };

        onChangeByNameValue("coverPhoto", file);
        toast.success(data?.message);
      },
      onError(error: any) {
        toast.error(error?.response?.data?.message);
      },
    }
  );

  const handleUplaod = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const formData = new FormData();
      const file = e.target.files[0];

      formData.append("file", file);
      // console.log(file,"FILEss", formData.get("file"))

      uploadMutate(formData);
    }
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    onSubmit(state);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">Name</label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder=""
          name="name"
          onChange={onChange}
          value={state.name}
          required={true}
        />
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Cover Photo
        </label>
        <input
          type="file"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder=""
          name="coverPhoto"
          onChange={handleUplaod}
          //   required={true}
        />
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Description
        </label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Enter Description"
          name="description"
          onChange={onChange}
          value={state.description}
        />
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="reset"
          data-modal-close="addDocuments"
          className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
        >
          {isLoading ? "Loading..." : "Submit"}
        </button>
      </div>
    </form>
  );
}
